import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import OutcomeCol from 'common/EventRow/OutcomeComponent/OutcomeCol';
import eventShape from 'common/PropTypes/eventShape';
import marketTypeShape from 'common/PropTypes/marketTypeShape';

import MarketTypeHeader from './MarketTypeHeader';

const MarketTypeOutrightView = ({
  data,
  event,
  expandedMarketTypes,
  isFavorite,
  marketType,
  setExpandedMarketTypes,
  suspended,
}) => {
  const { betGroups = [], id: marketTypeId, name, show: expandedByDefault } = marketType;

  const isExpanded = useMemo(
    () => expandedMarketTypes[marketTypeId] ?? expandedByDefault,
    [expandedByDefault, expandedMarketTypes, marketTypeId],
  );

  const sortedOutcomes = useMemo(
    () => data.rows.flat().sort((a, b) => a.odds - b.odds),
    [data.rows],
  );

  return (
    <div className="details-market-container">
      <MarketTypeHeader
        betGroups={betGroups}
        expandedMarketTypes={expandedMarketTypes}
        isExpanded={isExpanded}
        isFavorite={isFavorite}
        marketTypeId={marketTypeId}
        name={name}
        setExpandedMarketTypes={setExpandedMarketTypes}
      />
      {isExpanded && (
        <div className="MarketTypeDefaultView">
          {sortedOutcomes.map((outcome, index) => {
            // even if outright has fake outcome it doesn't make any sense to render it
            if (outcome.isFake) {
              return null;
            }

            const customName = outcome?.specifiers;

            return (
              <div className="MarketTypeDefaultView__row" key={`${marketTypeId}-${index}`}>
                <div className="MarketTypeDefaultView__cell odds-grid">
                  <OutcomeCol
                    className="primary row"
                    customName={customName}
                    dataTestId="event-details-outcome"
                    dataTestItemId={outcome.id}
                    event={event}
                    market={{ id: outcome.marketId }}
                    marketType={marketType}
                    outcome={outcome}
                    suspended={suspended}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

MarketTypeOutrightView.propTypes = {
  data: PropTypes.object.isRequired,
  event: eventShape.isRequired,
  expandedMarketTypes: PropTypes.objectOf(PropTypes.bool),
  isFavorite: PropTypes.bool,
  marketType: marketTypeShape.isRequired,
  setExpandedMarketTypes: PropTypes.func,
};

export default MarketTypeOutrightView;
